import React from 'react'
import { useState, useEffect } from 'react';
import RootAdmin from '../../../components/layouts/RootAdmin'
import { Button, Card, CardBody, CardHeader, Chip, DatePicker, Divider, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react'
import HeaderPage from '../../../components/elements/HeaderPage'
import { ArrowDownOnSquareIcon, ArrowPathIcon, CheckIcon, ClockIcon, DocumentArrowUpIcon, DocumentDuplicateIcon, DocumentPlusIcon, FunnelIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { BarChart } from '@mui/x-charts/BarChart';
import { SparkLineChart } from '@mui/x-charts';
import {HIGHCHART_URL, getFetcher} from '../../../services/api';
import useSWR from "swr";
import TipeSurat from '../../../enums/tipeSurat';
import toast from 'react-hot-toast';
import { formatDate, formatToDate } from '../../../services/helpers';
import { id } from 'date-fns/locale'; // Impor locale Indonesia
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function DashboardPage() {
    const currentDate = new Date();

    let month = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1
    let day = currentDate.getDate();
    const year = currentDate.getFullYear();

    // Ensure month and day are always two digits
    month = month.toString().padStart(2, '0');
    day = day.toString().padStart(2, '0');
    // Default tanggal saat ini
    const formattedDate = formatToDate(currentDate);


    const [date, setDate] = useState({
    endDate: formattedDate,
    startDate: formattedDate,
    });

    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    
    // Dulu pakai getFetcherDashoard (token API publik statis) sehingga backend tidak tahu
    // siapa yang login - itu sebabnya endpoint ini tidak bisa dibatasi per-PIC. Diganti ke
    // getFetcher (token user login) supaya scoping delegasi PIC Rekomendasi bisa jalan.
    const { data:DataBahanB3, isLoadingB3 } = useSWR(`/api/dashboard/permohonan/bahanb3?startDate=${date.startDate}&endDate=${date.endDate}`, getFetcher);
    const { data:DataJeniSurat, isLoadingSurat } = useSWR(`/api/dashboard/permohonan/jenis-surat?startDate=${date.startDate}&endDate=${date.endDate}`, getFetcher);
    const { data:DataStatus, isLoading, mutate } = useSWR(`/api/dashboard/permohonan/status?startDate=${date.startDate}&endDate=${date.endDate}`, getFetcher);
    
    const handleStartDate = (date) => {
        const formattedStartDate = formatToDate(date);
        setStartDate(formattedStartDate)
    };

    const handleEndDate = (date) => {
        const formattedStartDate = formatToDate(date);
    setEndDate(formattedStartDate)
        
        };
    const handleFilterDate = () => {
         // Validasi: Pastikan startDate tidak lebih besar dari endDate
        if(startDate === '' || endDate === '') {
            toast.error('Tanggal mulai dan tanggal akhir tidak boleh kosong.');
        }
    if (new Date(startDate?.split('-').reverse().join('-')) > new Date(endDate?.split('-').reverse().join('-'))) {
        toast.error('Tanggal mulai tidak boleh lebih besar dari tanggal akhir.');
        return;
      }
  
      // Set tanggal baru
      setDate({
        startDate,
        endDate,
      });
  
      // Mutasi untuk refetch data dengan tanggal baru
      mutate();
    };

    const permohonanBaru = DataJeniSurat?.responseData?.jenis_surat?.find(jenis => jenis?.tipe_surat === TipeSurat.BARU)?.count
    const penambahanUnit = DataJeniSurat?.responseData?.jenis_surat?.find(jenis => jenis?.tipe_surat === TipeSurat.PENAMBAHAN_KENDARAAN)?.count
    const penambahanJenisB3 = DataJeniSurat?.responseData?.jenis_surat?.find(jenis => jenis?.tipe_surat === TipeSurat.PENAMBAHAN_JENIS_B3)?.count
    const perpanjangan = DataJeniSurat?.responseData?.jenis_surat?.find(jenis => jenis?.tipe_surat === TipeSurat.PERPANJANGAN)?.count

    const labels = Array.isArray(DataBahanB3?.responseData)
    ? DataBahanB3.responseData.map((item) => item.nama_bahan)
    : [];
    const values = Array.isArray(DataBahanB3?.responseData)
        ? DataBahanB3.responseData.map((item) => item.count)
        : [];

    // Placeholder untuk perusahaan
    const labelsCom = Array.isArray(DataJeniSurat?.responseData?.perusahaan)
        ? DataJeniSurat.responseData.perusahaan.map((item) => item.company_name)
        : [];
    const valuesCom = Array.isArray(DataJeniSurat?.responseData?.perusahaan)
        ? DataJeniSurat.responseData.perusahaan.map((item) => item.count)
        : [];

    // Gunakan fallback jika data kosong
    const barChartData = labels.length > 0 && values.length > 0 ? { labels, values } : { labels: ["No Data"], values: [0] };
    const barChartDataCom = labelsCom.length > 0 && valuesCom.length > 0 ? { labelsCom, valuesCom } : { labelsCom: ["No Data"], valuesCom: [0] };

        // Data Status
    const statusData = DataStatus?.responseData || {};

    return (
        <RootAdmin>
             <HeaderPage
                title="Dashboard Rekomendasi"
                subtitle="Gambaran Umum"
                action={
                    <FilterForm
                        handleStartDate={handleStartDate}
                        handleEndDate={handleEndDate}
                        handleFilterDate={handleFilterDate}
                    />
                }
            />
            <div className='grid grid-cols-1 md:grid-cols-4 gap-3 pt-5'>
                <Card radius='sm' className='col-span-3'>
                    <CardBody>
                        <div className='flex flex-row gap-5'>
                            <div>
                                <h4 className="text-medium font-medium text-ink-400">Total Permohonan</h4>
                                <h1 className="text-5xl font-semibold pt-5">{DataJeniSurat?.responseData?.total_permohonan ?? 0}</h1>
                                <Chip size='sm' variant='flat' color='success' startContent={<ClockIcon className='size-4'/>}>dengan rata-rata proses {DataJeniSurat?.responseData?.rata_rata_proses ?? 0} hari</Chip>
                            </div>
                            <div className='w-full'>
                                <SparkLineChart data={[1, 4, 2, 5, 7, 2, 4, 6]} height={100} />
                            </div>
                        </div>
                        <Divider className="my-4" />
                        <div className="flex items-center gap-3">
                            <div className='w-full flex flex-col gap-4'>
                                <div className='flex items-center gap-2'>
                                    <Button isIconOnly variant='flat' color='primary' size='sm' className='rounded-full'><DocumentPlusIcon className='size-4'/></Button>
                                    <span className='text-xs text-ink-400 capitalize'>Permohonan Baru</span>
                                </div>
                                <span className='text-2xl font-bold'>{permohonanBaru ?? 0}</span>
                            </div>
                            <Divider orientation="vertical" />
                            <div className='w-full flex flex-col gap-4'>
                                <div className='flex items-center gap-2'>
                                    <Button isIconOnly variant='flat' color='warning' size='sm' className='rounded-full'><DocumentDuplicateIcon className='size-4'/></Button>
                                    <span className='text-xs text-ink-400 capitalize'>penambahan unit kendaraan</span>
                                </div>
                                <span className='text-2xl font-bold'>{penambahanUnit ?? 0}</span>
                            </div>
                            <Divider orientation="vertical" />
                            <div className='w-full flex flex-col gap-4'>
                                <div className='flex items-center gap-2'>
                                    <Button isIconOnly variant='flat' color='danger' size='sm' className='rounded-full'><DocumentDuplicateIcon className='size-4'/></Button>
                                    <span className='text-xs text-ink-400 capitalize'>penambahan jenis b3</span>
                                </div>
                                <span className='text-2xl font-bold'>{penambahanJenisB3 ?? 0}</span>
                            </div>
                            <Divider orientation="vertical" />
                            <div className='w-full flex flex-col gap-4'>
                                <div className='flex items-center gap-2'>
                                    <Button isIconOnly variant='flat' color='secondary' size='sm' className='rounded-full'><DocumentArrowUpIcon className='size-4'/></Button>
                                    <span className='text-xs text-ink-400 capitalize'>perpanjangan</span>
                                </div>
                                <span className='text-2xl font-bold'>{perpanjangan ?? 0}</span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                <Card radius='sm' className='col-span-1'>
                    <CardHeader className='text-primary font-semibold text-lg'>Permohonan Masuk Hari Ini</CardHeader>
                    <CardBody className='flex flex-col gap-4'>
                        <div className='flex items-center gap-3'>
                            <Button isIconOnly variant='flat' color='primary' size='sm' className='rounded-full'><ArrowDownOnSquareIcon className='size-4'/></Button> 
                            <div className='flex flex-col gap-1'>
                                <span className='text-ink-400 text-xs uppercase leading-3'>Masuk</span>
                                <span className='text-lg font-semibold leading-3'>{DataStatus?.responseData?.MASUK ?? 0}</span>
                            </div>
                        </div>
                        <div className='flex items-center gap-3'>
                            <Button isIconOnly variant='flat' color='primary' size='sm' className='rounded-full'><ArrowPathIcon className='size-4'/></Button> 
                            <div className='flex flex-col gap-1'>
                                <span className='text-ink-400 text-xs uppercase leading-3'>Proses</span>
                                <span className='text-lg font-semibold leading-3'>{DataStatus?.responseData?.PROSES ?? 0}</span>
                            </div>
                        </div>
                        <div className='flex items-center gap-3'>
                            <Button isIconOnly variant='flat' color='primary' size='sm' className='rounded-full'><CheckIcon className='size-4'/></Button> 
                            <div className='flex flex-col gap-1'>
                                <span className='text-ink-400 text-xs uppercase leading-3'>Selesai</span>
                                <span className='text-lg font-semibold leading-3'>{DataStatus?.responseData?.SELESAI ?? 0}</span>
                            </div>
                        </div>
                        <div className='flex items-center gap-3'>
                            <Button isIconOnly variant='flat' color='primary' size='sm' className='rounded-full'><XMarkIcon className='size-4'/></Button> 
                            <div className='flex flex-col gap-1'>
                                <span className='text-ink-400 text-xs uppercase leading-3'>Tolak</span>
                                <span className='text-lg font-semibold leading-3'>{DataStatus?.responseData?.DITOLAK ?? 0}</span>
                            </div>
                        </div>
                    </CardBody>
                </Card>  
                <Card radius='sm' className='col-span-4'>
                        <div>
                            <CardHeader>
                                <span className='text-primary text-xl font-bold'>Jenis B3 Terbanyak</span>
                            </CardHeader>
                            <CardBody className='w-full flex flex-col items-center py-5 text-center'>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                    chart: {
                                        type: "column",
                                        height: 300, // Set the height of the chart
                                        width: null, // Let Highcharts adjust to the container width
                                    },
                                    title: {
                                        text: "Jenis B3 Terbanyak",
                                    },
                                    xAxis: {
                                        categories: barChartData.labels,
                                        title: {
                                            text: "Jenis B3",
                                        },
                                    },
                                    yAxis: {
                                        min: 0,
                                        title: {
                                            text: "Jumlah",
                                        },
                                        labels: {
                                            overflow: "justify",
                                        },
                                    },
                                    series: [
                                        {
                                            name: "Jumlah",
                                            data: barChartData.values,
                                        },
                                    ],
                                    exporting: {
                                        url: HIGHCHART_URL,
                                        enabled: true,
                                        showTable: true,
                                    },
                                }}
                            />
                            </CardBody>
                        </div>
                          <div>
                            <CardHeader>
                                <span className='text-primary text-xl font-bold'>Perusahaan</span>
                            </CardHeader>
                            <CardBody className='w-full flex flex-col items-center py-5 text-center'>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={{                                    
                                    chart: {
                                        type: "column",
                                        height: 300, // Set the height of the chart
                                        width: null, // Let Highcharts adjust to the container width
                                    },
                                    title: {
                                        text: "Perusahaan",
                                    },
                                    xAxis: {
                                        categories: barChartDataCom.labelsCom,
                                        title: {
                                            text: "Perusahaan",
                                        },
                                    },
                                    yAxis: {
                                        min: 0,
                                        title: {
                                            text: "Jumlah",
                                        },
                                        labels: {
                                            overflow: "justify",
                                        },
                                    },
                                    series: [
                                        {
                                            name: "Jumlah",
                                            data: barChartDataCom.valuesCom,
                                        },
                                    ],
                                    exporting: {
                                        url: HIGHCHART_URL,
                                        enabled: true,
                                        showTable: true,
                                    },
                                }}
                            />
                            </CardBody>
                        </div>
                </Card>
                <div className='col-span-4'>
                    <Table aria-label="Example static collection table">
                        <TableHeader>
                            <TableColumn>Perusahaan</TableColumn>
                            <TableColumn>Jumlah</TableColumn>
                        </TableHeader>
                        <TableBody isLoading={isLoadingSurat}>
                            {DataJeniSurat?.responseData?.perusahaan?.map((data,index) => (
                                <TableRow key={index}>
                                    <TableCell>{data.company_name}</TableCell>
                                    <TableCell>{data.count} Permohonan</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </RootAdmin>
    )
}

function FilterForm({ handleStartDate, handleEndDate, handleFilterDate }) {
    return (
        <Dropdown closeOnSelect={false}>
            <DropdownTrigger>
                <Button radius="sm" variant="bordered" startContent={<FunnelIcon className="size-4" />}>
                    Saring
                </Button>
            </DropdownTrigger>
            <DropdownMenu>
                <DropdownItem>
                    <DatePicker size="sm" label="Tanggal Mulai" labelPlacement="outside" onChange={handleStartDate} format="dd/MM/yyyy"  />
                </DropdownItem>
                <DropdownItem>
                    <DatePicker size="sm" label="Tanggal Akhir" labelPlacement="outside" onChange={handleEndDate} format="dd/MM/yyyy"/>
                </DropdownItem>
                <DropdownItem>
                    <Button size="sm" color="primary" onClick={handleFilterDate}>
                        Terapkan
                    </Button>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
}
